import { render, staticRenderFns } from "./ConversationActionsMedia.vue?vue&type=template&id=08bb0939&"
import script from "./ConversationActionsMedia.vue?vue&type=script&lang=js&"
export * from "./ConversationActionsMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports